import axios from "axios";
import { baseUrlBengkel } from "../../config/api/apiConfig";

class PurchaseOrderPartApiService {
    private axios = axios.create({
        baseURL: baseUrlBengkel,
    });

    private axiosFile = axios.create({
        baseURL: baseUrlBengkel,
        responseType: 'blob'
    });

    public setToken(token: string) {
        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        this.axiosFile.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }

    public async create(inputData?: any) {
        try {
            return await this.axiosFile.post<any>('/purchase-order-part/create', inputData);
        } catch (e: any) {
            console.log(e);
            throw new Error(e.response.data.message);
        }
    }
}

export const purchaseOrderPartApiService = new PurchaseOrderPartApiService();
